import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { makeLoadableCard } from 'crm-events-components/internal/helpers/makeLoadableCard';
import { jsx as _jsx } from "react/jsx-runtime";
export const emailUnbounceConfig = {
  component: makeLoadableCard(() => import( /* webpackChunkName: "compact-card-unbounce" */'conversations-thread-view-crm-events/email/CompactEmailUnbounceEvent')),
  minkowskiEventNameForFiltering: 'EMAIL_UNBOUNCES',
  getTimelineCardErrorMsg: _ref => {
    let commonProps = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    return /*#__PURE__*/_jsx(FormattedJSXMessage, Object.assign({
      message: "timeline.timelineCardError.eventEmailUnbounce.error_jsx"
    }, commonProps));
  }
};